export default "__VITE_ASSET__0393db0d__"